import { BaseProps } from '@src/baseProps';
import mapValues from 'lodash/mapValues';

type TestIds<Type> = {
  [Key in keyof Type]: string;
};

function createTestIds<T>(component: string, testIds: TestIds<T>): TestIds<T> {
  return mapValues(testIds, (value) => `${component}.${value}`);
}

function getTestId(props: BaseProps): string | undefined {
  return props.testId ?? props['data-testid'];
}

export { createTestIds, getTestId };
